import React, { useEffect } from "react";
import styled from "styled-components";
import { func, object as obj } from "prop-types";
import { carePageSubmitted } from "data/segmentCustomEvents";
import Copy from "components/shared/Copy";
import OnboardingInput from "components/onboarding/components/OnboardingInput";
import agents from "icons/agents.png";

const AgentPictures = styled.img`
  width: 230px;
`;

const PhonePage = ({
  formData,
  fieldValidation,
  handleChange,
  invalidMessages
}) => {
  useEffect(() => {
    carePageSubmitted();
  }, []);

  return (
    <>
      <Copy color="darkBlue" margin="0 0 1rem" size={1} weight="600">
        Step 2: Phone Number
      </Copy>
      <AgentPictures src={agents} alt="agent pictures" />
      <Copy margin="1rem auto" size={0.8} width="250px">
        Our care team will call you to learn about your needs and search for
        suitable carers
      </Copy>
      <OnboardingInput
        error={invalidMessages.phone_number}
        name="phone_number"
        placeholder="Your phone number"
        onBlur={fieldValidation}
        onChange={handleChange}
        type="tel"
        value={formData.phone_number}
        width="270px"
      />
    </>
  );
};

PhonePage.propTypes = {
  fieldValidation: func.isRequired,
  formData: obj.isRequired,
  handleChange: func.isRequired,
  invalidMessages: obj.isRequired
};

export default PhonePage;
